import { useQuery } from '@tanstack/react-query';
import { getOrderTree } from '../orders.api';

/** Trees are never cached client-side either (AD-9: "tree per aanvraag") — always fresh. */
export function useOrderTree(orderNumber: string) {
  return useQuery({
    queryKey: ['orders', 'tree', orderNumber],
    queryFn: () => getOrderTree(orderNumber),
    staleTime: 0,
  });
}
